const resolvePropertyByString = (obj, string) => {

  string = string.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  string = string.replace(/^\./, '');           // strip a leading dot
  var a = string.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    if (obj) {
      var k = a[i];
      if (k in obj) {
        obj = obj[k];
      } else {
        return;
      }
    }
  }
  return obj;
}

module.exports = {
  resolvePropertyByString: resolvePropertyByString
};
